/**
 * Badge colour mapping for Exterior Improvement Application statuses (#363).
 *
 * Keyed by the INTEGER `ExteriorApplicationStatus` so the UI never diverges
 * from the canonical enum in `application-status.ts`. Kept as plain hex values
 * (not theme lookups) so the mapping is pure and unit-testable without a theme
 * provider — mirrors the `styles/components/badges.ts` `getStatusStyle` convention.
 */

import { ExteriorApplicationStatus } from './application-status';

export interface ApplicationStatusStyle {
	backgroundColor: string;
	color: string;
}

const WHITE = '#ffffff';

const STATUS_STYLE: Record<ExteriorApplicationStatus, ApplicationStatusStyle> = {
	[ExteriorApplicationStatus.Submitted]: { backgroundColor: '#2196f3', color: WHITE },
	[ExteriorApplicationStatus.Reviewed]: { backgroundColor: '#1976d2', color: WHITE },
	[ExteriorApplicationStatus.NeedsAdditionalInfo]: { backgroundColor: '#ff9800', color: WHITE },
	[ExteriorApplicationStatus.SubmittedToBoard]: { backgroundColor: '#9c27b0', color: WHITE },
	[ExteriorApplicationStatus.Approved]: { backgroundColor: '#4caf50', color: WHITE },
	[ExteriorApplicationStatus.Rejected]: { backgroundColor: '#bc3433', color: WHITE },
	[ExteriorApplicationStatus.Withdrawn]: { backgroundColor: '#616161', color: WHITE },
};

const FALLBACK_STYLE: ApplicationStatusStyle = { backgroundColor: '#999999', color: WHITE };

/** Badge style for a raw integer status, tolerant of unknown values. */
export const applicationStatusStyle = (status: number): ApplicationStatusStyle =>
	STATUS_STYLE[status as ExteriorApplicationStatus] ?? FALLBACK_STYLE;
